import React, { ChangeEvent, useCallback } from "react";
import { Select } from "../Form/Inputs/Select/Select";
import { ComparableSuite } from "./SuitesComparison";

type Props = {
  suites: ComparableSuite[];
  selectedSuite: ComparableSuite;
  selectedSuites: ComparableSuite[];
  onChange: (value: ComparableSuite) => void;
  className?: string;
  dataContentPiece: string;
};

export const SuiteSelect: React.FC<React.PropsWithChildren<Props>> = ({
  suites,
  selectedSuite,
  selectedSuites,
  onChange,
  className,
  dataContentPiece
}) => {
  const _onChange = useCallback(
    (e: ChangeEvent<HTMLSelectElement>) => {
      const suiteKey = e.target.value;
      const suite = suites.find((s) => s._key == suiteKey);

      if (suite) onChange(suite);
    },
    [onChange, suites]
  );

  return (
    <Select
      dataContentPiece={dataContentPiece}
      value={selectedSuite._key}
      className={className}
      onChange={_onChange}
    >
      {suites.map((suite) => {
        const disabled =
          selectedSuites.includes(suite) && suite != selectedSuite;
        return (
          <option key={suite._key} value={suite._key} disabled={disabled}>
            {suite.name}
          </option>
        );
      })}
    </Select>
  );
};

//*** WITH DROP DOWN */
// export const SuiteSelect: React.FC<Props> = ({
//   suites,
//   selectedSuite,
//   onChange,
//   className
// }) => {
//   const label = selectedSuite.name;

//   const _onChange = useCallback(
//     (value: TMPSuite) => {
//       if (value) onChange(value);

//       document.dispatchEvent(new Event("click")); // force close dropdown
//     },
//     [onChange]
//   );

//   return (
//     <DropDown
//       label={label}
//       className={className}
//       closeOnClickOutside
//       labelEllipsis
//     >
//       {suites.map((suite) => (
//         <SuiteOption
//           key={suite._key}
//           suite={suite}
//           checked={selectedSuite._key == suite._key}
//           onChange={_onChange}
//         ></SuiteOption>
//       ))}
//     </DropDown>
//   );
// };

// type SuiteOptionProps = {
//   suite: TMPSuite;
//   onChange: (value: TMPSuite) => void;
//   checked: boolean;
// };
// const SuiteOption: React.FC<SuiteOptionProps> = ({
//   suite,
//   onChange,
//   checked
// }) => {
//   const _onChange = useCallback(() => {
//     onChange(suite);
//   }, [onChange, suite]);

//   return (
//     <BarCheckbox label={suite.name} onChange={_onChange} checked={checked}>
//       <div>Price: ???</div>
//     </BarCheckbox>
//   );
// };
